import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import AgentNavbar from "../../component/AgentNavbar";
import { baseurl } from "../../component/Baseurl";
import HotelFilter from "./AgentComp/HotelFilter";
import { Plus, Star, MapPin, CheckSquare } from "react-feather";


function HotelResult() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const cityId = queryParams.get("from");
  const departure = queryParams.get("departure");
  const returnDate = queryParams.get("return");
  const day = queryParams.get("day");
  const rooms = JSON.parse(queryParams.get("rooms")) || [];
  
  const [hotels, setHotels] = useState([]);
  const [filteredHotels, setFilteredHotels] = useState([]); // State for filtered results
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  // const [hotelMarkup, setHotelMarkup] = useState(null);
  const agentid = localStorage.getItem("agent_id") || '2';

console.log("agent id",agentid );

  const [minPrice, setMinPrice] = useState("");
  const [maxPrice, setMaxPrice] = useState("");
  const [hotelName, setHotelName] = useState("");

 


  const [hotelMarkup, setHotelMarkup] = useState(0); // Initialize with 0

  useEffect(() => {
    if (!agentid) return console.error("No agent ID found in localStorage");
  
    const fetchMarkupDetails = async () => {
      try {
        const { data } = await axios.get(`${baseurl}getMarkupDetailsById/${agentid}`);
  
        if (data?.message === "Markup details fetched successfully") {
          const admin_hotel_markup = Number(data.adminMarkup.admin_hotel_markup) || 0;
          const distributor_hotel_markup = Number(data.distributorMarkup.distributor_hotel_markup) || 0;
          const hotel_markup_amount = Number(data.agentMarkup.hotel_markup_amount) || 0;
  
          const totalMarkup = admin_hotel_markup + distributor_hotel_markup + hotel_markup_amount;
  
          console.log("Hotel Markup Amount:", totalMarkup);
          setHotelMarkup(totalMarkup); // Update state correctly
        } else {
          console.error("Unexpected API response", data);
        }
      } catch (error) {
        console.error("API Error:", error);
      }
    };
  
    fetchMarkupDetails();
  }, [agentid]);
  
  
  
  

  

  useEffect(() => {
    const fetchHotels = async () => {
      try {
        const response = await axios.post(`${baseurl}searchHotel`, {
          cityId,
          departure,
          return: returnDate,
          rooms,
        });

        const hotelResults =
          response.data?.Search?.HotelSearchResult?.HotelResults || [];
        setHotels(hotelResults);
        setFilteredHotels(hotelResults);
        setLoading(false);
      } catch (err) {
        console.error("Error fetching hotels:", err);
        setError("Failed to fetch hotel results.");
        setLoading(false);
      }
    };

    fetchHotels();
  }, []);

  // Filtering logic
  useEffect(() => {
    let filtered = hotels;

    if (hotelName) {
      filtered = filtered.filter((hotel) =>
        hotel.HotelName.toLowerCase().includes(hotelName.toLowerCase())
      );
    }

    if (minPrice || maxPrice) {
      filtered = filtered.filter((hotel) => {
        const price = parseFloat(hotel.Price?.RoomPrice || 0);
        return (
          (!minPrice || price >= parseFloat(minPrice)) &&
          (!maxPrice || price <= parseFloat(maxPrice))
        );
      });
    }

    setFilteredHotels(filtered);
  }, [hotelName, minPrice, maxPrice, hotels]);

  return (
    <>
      <AgentNavbar />
      <HotelFilter/>

      <div className="container-fluid  ">
        
        <div className="container bg-2 midle">
          <div className="row g-3">
            <div className="col-md-3 ">
              <div className="box_prie1 text-start border rounded p-2">

              <div className="sum1 w100 p-3 text-white text-center">
                          <div className="text-center">
                          Filter Here
                          </div>
                        </div>
                {/* <h4>Filter Here</h4> */}
                <div className="row g-1">
                  <div className="col-md-12 ">
                    <label>Hotel Name</label>
                    <input
                      type="text"
                      className="form-control input-field  mb-0"
                      placeholder="Search by hotel name"
                      value={hotelName}
                      onChange={(e) => setHotelName(e.target.value)}
                    />
                  </div>
                  <div className="col-md-12 ">
                    <label>Min Price</label>
                    <input
                      type="number"
                      className="form-control input-field   mb-0"
                      placeholder="Min price"
                      value={minPrice}
                      onChange={(e) => setMinPrice(e.target.value)}
                    />
                  </div>
                  <div className=" col-md-12">
                    <label>Max Price</label>
                    <input
                      type="number"
                      className="form-control input-field   mb-0"
                      placeholder="Max price"
                      value={maxPrice}
                      onChange={(e) => setMaxPrice(e.target.value)}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-9">
              {loading && (
                <div>
                  <div className="d-flex justify-content-center align-items-center vh-100  text-white">
                    <span className="loader1">
                      <span className="text-white"></span>
                    </span>
                  </div>
                </div>
              )}
              {error && <p className="text-danger">{error}</p>}

              {filteredHotels.length > 0 ? (
                <div>
                  {filteredHotels.map((hotel, index) => (
                    <div key={index}>
                      <div className="row g-2 njhvrfg">
                        <div className="col-md-3">
                          <div className="p-2">
                            <img
                              src={hotel.HotelPicture}
                              className="rounded img-fluid"
                              alt={hotel.HotelName}
                            />
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="px-2">
                            <a
                              href={`/hotel-details?hotelToken=${hotel.ResultToken}`} target="_blank"
                            >
                              <h3 className="text-start offerprice">
                                {hotel.HotelName}
                              </h3>
                            </a>
                            <p className="text-start litm"><MapPin size={15}/>&nbsp;{hotel.HotelAddress}</p>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="hot-page2-alp-ri-p3 tour-alp-ri-p3">
                            <span className="hot-list-p3-1">
                              Prices Starting
                            </span>
                            <span className="offerprice">
                              {/* {hotel?.Price?.CurrencyCode === "INR"
                                ? "₹"
                                : hotel?.Price?.CurrencyCode} */}

                              {/* {hotel.Price?.OfferedPriceRoundedOff} &nbsp; */}


                              {hotel?.Price?.CurrencyCode === "INR"
                                ? "₹"
                                : hotel?.Price?.CurrencyCode}
 
                              {/* {(Number(hotel.Price?.RoomPrice) || 0) + all_markup} */}
                              {(Number(hotel.Price?.OfferedPriceRoundedOff) || 0) + hotelMarkup}
                            </span>

                            <span className="romdate">Per Night</span>
                            <span className="hot-list-p3-4">
                              <a
                                href={`/hotel-details?hotelToken=${hotel.ResultToken}&day=${day}`}
                                target="_blank"
                                className="hot-page2-alp-quot-btn"
                              >
                                Book Now
                              </a>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                !loading && <p>No hotels found.</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default HotelResult;
